import { CircleAlert, CircleCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { AnalyticsDestinationTestResult } from '@nucleus-commerce/api-client/admin';
import { Alert, AlertDescription, AlertTitle } from '@nucleus-commerce/ui/components/alert';
import { cn } from '@nucleus-commerce/ui/lib/utils';

/** The platform's answer to a test page_view: accepted or refused, its HTTP status and body. */
export function TestResult({ result }: { result: AnalyticsDestinationTestResult }) {
  const { t } = useTranslation('analytics');
  const Icon = result.ok ? CircleCheck : CircleAlert;
  return (
    <Alert
      variant={result.ok ? 'default' : 'destructive'}
      role="status"
      data-testid="destination-test-result"
      className={cn(result.ok && 'border-success/40 text-success')}
    >
      <Icon aria-hidden />
      <AlertTitle>{result.ok ? t('test.ok') : t('test.failed')}</AlertTitle>
      <AlertDescription className="flex flex-col gap-1">
        <span className="font-mono text-xs tabular-nums">
          {result.status !== null
            ? t('test.httpStatus', { status: result.status })
            : t('test.noStatus')}
        </span>
        {result.excerpt ? (
          <span className="text-foreground/80 flex flex-col gap-0.5">
            <span className="text-xs font-medium">{t('test.excerpt')}</span>
            <code className="bg-muted rounded px-1.5 py-1 font-mono text-xs break-all">
              {result.excerpt}
            </code>
          </span>
        ) : null}
      </AlertDescription>
    </Alert>
  );
}
